import React from "react";
import {
  updateCustomerPlus,
  getCustomerPlus,
} from "redux/actions/customerPlus";
import { NormalInput, NormalButton } from "component/common";
import { bindActionCreators } from "redux";
// import { addAssignReferrer } from "redux/actions/customerPlus";
import { getCommonApi } from "redux/actions/common";
import _ from "lodash";
import { updateForm } from "redux/actions/common";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import SimpleReactValidator from "simple-react-validator";

class AssignReferrerClass extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      itemTypeOptions: [],
      customerClassOptions: [],
      itemDivOptions: [],

      point_value: 0,
      isactive: true,
      reward_item_type: "",
      isMounted: true,

      brand_ids: "",
      formFields: {
        custId: "",
        custName: "",
      },
      customerOption: [],

      customer: "",
    };
  }

  componentWillUnmount() {
    this.state.isMounted = false;
  }

  updateState = async (data) => {
    if (this.state.isMounted) await this.setState(data);
  };

  componentDidMount = async () => {
    let { basicApptDetail, selectedCart, customerDetail } = this.props;
    console.log(basicApptDetail, "basicApptDetail");
    console.log(customerDetail, "customerDetail");
    let cust = localStorage.getItem("customer");
    //console.log(cust, "getitem");
    this.setState({
      customer: localStorage.getItem("customer"),
    });
    if (basicApptDetail.custName) {
      //console.log(basicApptDetail, "basicApptDetail");
      let { formFields } = this.state;
      formFields["custId"] = basicApptDetail.custId;
      formFields["custName"] = customerDetail.who_referred_me;

      //formFields["custName"] = basicApptDetail.custName;
      //formFields["cust_referby_code"] = basicApptDetail.cust_referby_code;
      //formFields["who_referred_me"] = customerPlusDetail.who_referred_me;
      this.setState({ formFields });
    }
    await this.props.getCustomerPlus(this.props?.id);
  };

  onChange = (e) => {
    this.updateState({ [e.target.name]: e.target.value });
  };
  handleSearch = async (event) => {
    // event.persist();
    let { formFields, visible } = this.state;
    formFields.custName = event.target.value;
    await this.setState({ formFields, visible: true });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async () => {
        this.search();
      }, 500);
    }
    this.debouncedFn();
  };

  search = (searchString) => {
    let { formFields } = this.state;
    this.props
      .getCommonApi(`custappt/?search=${formFields.custName}`)
      .then((key) => {
        let { status, data } = key;

        if (status === 200) {
          // for (let value of data) {
          //     customerList.push({ value: value.id, label: value.emp_name })
          //

          const temp = data.filter((data) => {
            if (data.id !== parseInt(localStorage.getItem("customer"))) {
              return data;
            }
          });
          console.log(temp, "temp");
          this.setState({ customerOption: temp });
        }
      });
  };
  handleClick = (key) => {
    if (!this.state.visible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    if (this.state.visible) {
      let { basicApptDetail } = this.props;
      this.search(basicApptDetail);
    }
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  };
  ///////////////
  handleSelectCustomer = async (data) => {

    console.log(data, "selected customer");
    let { formFields } = this.state;
    formFields["custId"] = data.id;
    formFields["custName"] = data.cust_name;

    await this.setState({
      formFields,
      search: "",
      customerOption: [],
    });
    await this.props.updateForm("basicApptDetail", formFields);
    console.log(this.props.basicApptDetail, "details");
    this.handleClick();
  };
  handleSubmit = async () => {
    let { customerDetail, customerPlusDetail } = this.props;
    console.log(this.props.id, "id");
    console.log(this.state.formFields.custId, "referral id");
    console.log(customerDetail?.cust_dob, "cust dob");

    if (this.props.id) {
      let formattedDob = "";
      if (customerDetail?.cust_dob === null || customerDetail?.cust_dob === "" || customerDetail?.cust_dob === undefined) {
        formattedDob = null;
      } else {
        const [day, month, year] = customerDetail?.cust_dob.split("-");
        console.log(day, month, year, "dob");
        formattedDob = `${year}-${month}-${day}`;
      }
      let body = {
        cust_referby_code: this.state.formFields.custId,
        cust_id: this.props.id,
        cust_email: customerPlusDetail?.cust_email,
        cust_name: customerPlusDetail?.cust_name,
        cust_phone1: customerPlusDetail?.cust_phone1,
        cust_remark: customerPlusDetail?.cust_remark,
        cust_phone2: customerPlusDetail?.cust_phone2,
        Cust_Classid: customerPlusDetail?.Cust_Classid,
        Cust_Groupid: customerPlusDetail?.Cust_Groupid,
        Cust_Sourceid: customerPlusDetail?.Cust_Sourceid,
        Cust_titleid: customerPlusDetail?.Cust_titleid,
        class_expiry: customerPlusDetail?.class_expiry,
        cust_address: customerPlusDetail?.cust_address,
        cust_address1: customerPlusDetail?.cust_address1,
        cust_address2: customerPlusDetail?.cust_address2,
        cust_joindate: customerPlusDetail?.cust_joindate,
        cust_nric: customerPlusDetail?.cust_nric,
        cust_postcode: customerPlusDetail?.cust_postcode,
        cust_refer: customerPlusDetail?.cust_refer,
        Cust_sexesid: customerPlusDetail?.Cust_sexesid,
      };
      //Cust_sexesid: customerPlusDetail?.Cust_sexesid,
      //if (formattedDob != "" && formattedDob != null) {
      //  body.cust_dob = formattedDob;
      //}

      console.log(body.cust_referby_code, "cust_referby_code");
      this.props
        .updateCustomerPlus(this.props.id + "/", JSON.stringify(body))
        .then((res) => {
          console.log(res, "Updated Response");
        })
        .catch((err) => {
          console.log(err, "Error");
        });
    } else {
      alert("hi");
    }
  };
  ////////////////

  handleClick = (key) => {
    if (!this.state.visible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    if (this.state.visible) {
      let { basicApptDetail } = this.props;
      this.search(basicApptDetail);
    }
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  };

  render() {
    let { formFields, visible, customerOption } = this.state;
    let { t } = this.props;
    return (
      <div className="treatment-account credit-note row">
        <div className="col-md-12 col-12 mt-3 mb-4">
          <div className="row mt-4">
            <div className="col-1 ml-3 px-1 fs-18 text-black text-center font-weight-600 text-nowrap">
              Select Referrer
            </div>
            <div className="col-3">
              <NormalInput
                placeholder="Search Referrer.."
                value={formFields.custName}
                name="custName"
                onChange={this.handleSearch}
                onClick={this.handleClick}
              />
              {/* {this.validator.message(
                "customerName",
                formFields.custName,
                "required"
              )} */}
            </div>
            {visible ? (
              <div className="customerSearch-block">
                <div className="d-flex mt-4 table table-header w-100 m-0">
                  <div className="col-2">{t("Name")}</div>
                  <div className="col-2">{t("Phone")}</div>
                  <div className="col-2">{t("Cust Code")}</div>
                  <div className="col-2">{t("Reference")}</div>
                  <div className="col-3">{t("Email")}</div>
                  <div className="col-1 d-none">{t("NRIC")}</div>
                </div>
                <div className="response-table w-100">
                  {customerOption.length > 0 ? (
                    customerOption.map((item, index) => {
                      return (
                        <div
                          className="row m-0 table-body w-100 border"
                          onClick={() => this.handleSelectCustomer(item)}
                          key={index}
                        >
                          <div className="col-2">{item.cust_name}</div>
                          <div className="col-2">{item.cust_phone2}</div>
                          <div className="col-2">{item.cust_code}</div>
                          <div className="col-2">{item.cust_refer}</div>
                          <div className="col-3">{item.cust_email}</div>
                          <div className="col-1 d-none">{item.cust_nric}</div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-center w-100">
                      {t("No Data are available")}
                    </div>
                  )}
                </div>
              </div>
            ) : null}
            <div className="col-1">
              <NormalButton
                mainbg={true}
                label={"Profile"}
                // onClick={() => this.handlebrandDialog()}
              />
            </div>
          </div>
        </div>
        <hr class="new5" />
        <div className="d-flex col-4 mt-3">
          {" "}
          <label className=" mt-2 text-nowrap fs-18 text-blue font-weight-600 fw-600 mx-2 ">
            Referrer :
          </label>
          <NormalInput
            value={formFields.custName}
            name="custName"
            onChange={this.handleSearch}
            disabled={true}
          />
        </div>

        <div className="d-flex justify-content-start mt-5 col-12">
          <div className="col-1">
            <NormalButton
              mainbg={true}
              label={"Confirm"}
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  rewardPolicyList: state.customerPlus.rewardPolicyList,
  basicApptDetail: state.appointment.basicApptDetail,
  customerDetail: state.customer.customerDetail,
  customerPlusDetail: state.customerPlus.customerPlusDetail,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // addAssignReferrer,
      getCommonApi,
      updateForm,
      updateCustomerPlus,
      getCustomerPlus,
    },
    dispatch
  );
};

export const AssignReferrer = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AssignReferrerClass)
);